import { BCMSRecord, useBCMSContext, useStateManager, useWorkflow } from "@bcm-dev/bcms-vite";
import { PageContainer } from 'components/shared';
import CheckView from 'components/shared/views/CheckView';
import { PrimaryButton, SecondaryButton } from 'components/ui';
import Classes from "model";
import React from 'react';
import "./styles.css";

/**
 * @function CheckImageConfirmPage
 * @return {React.Component}
 * @exported true
 * @description description
 */

export default function CheckImageConfirmPage(props){
  const { goStep, prevStep } = useWorkflow() ?? {};
  const globalController = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, globalController);
  const data = { ...getDefaultPageData(), ...props.data ?? {} };
  const ui = { ...getDefaultPageUI(), ...props.ui ?? {} };

  const state = { data, ui };
  const controller = (state, setState) => ({
      data: state.data,
      ui: state.ui,

      onRetakeClick: () => prevStep(),

      onUseClick: () => {
        if(state.ui.checkFrontView.isSet) {
          goStep(0);
        } else {
          goStep(6);
        }
      },
  });

  return(
    <PageContainer className="check-image-confirm-page" state={state} controller={controller}>
      <PageContent/>
    </PageContainer>
  );
}

export const getDefaultPageData = () => ({
  
});
export const getDefaultPageUI = () => ({
  
});

function PageContent() {
  const { onRetakeClick, onUseClick } = useStateManager();
  
  return (
    <div className="check-image-page-content flex-container flex-vertical">
    <CheckView />
      <div className="check-overlay-container">
        <div className="overlay-item-container flex-container flex-vertical align-center justify-right">
          <div className="flex-container flex-horizontal align-center button-container">
            <SecondaryButton text="Retake" onClick={ onRetakeClick } />
            <PrimaryButton text="Use" onClick={ onUseClick } />
          </div>
        </div>
      </div>
    </div>
  );
}